export const onlyDigit = (value: string) => value === '' || value.match(/^\d+$/);
